import auth from '@/router/auth'
import QuestionCreate from '@/components/questions/Create'
import QuestionUpdate from '@/components/questions/Update'
import QuestionShow from '@/components/questions/Show'

export default [
  {
    path: '/courses/:course_id/chapters/:chapter_id/test-kits/:test_kit_id/questions/create',
    name: 'questions-create',
    component: QuestionCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/:course_id/chapters/:chapter_id/test-kits/:test_kit_id/questions/update/:question_id',
    name: 'questions-update',
    component: QuestionUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/:course_id/chapters/:chapter_id/test-kits/:test_kit_id/questions/show/:question_id',
    name: 'questions-show',
    component: QuestionShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/questions/router.js